import { selectAllStrings } from '../language/languageSlice';
import { useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import '../../stylesheets/AddPhotoModal.css';
import ErrorModal from '../../app/ErrorModal';
import { addPhoto } from './gallerySlice';
import { unwrapResult } from '@reduxjs/toolkit';
import ConfirmModal from '../../app/ConfirmModal';
import { logEvent, EVENTS } from '../../lib/event-helper';

const AddPhotoModal = ({onGoBack, poiId}) => {
    const [error, setError] = useState('');
    const [successTitle, setSuccessTitle] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const strings = useSelector(selectAllStrings);
    const [addRequestStatus, setAddRequestStatus] = useState('idle');

    const userId = useSelector(state => state.user.cardData.profile_id);
    const photoRef = useRef(null);
    const dispatch = useDispatch();


    const onSelectClicked = (event) => {
        event.preventDefault();
        photoRef.current.click();
    };

    const onPhotoChanged = async (event) => {
        let photo = event.target.files[0];
        try {
            let resultAction;
            setAddRequestStatus('pending');
            resultAction = await dispatch(addPhoto({userId, poiId, photo}));
            unwrapResult(resultAction);
            if (resultAction.payload == 1) {
                logEvent(EVENTS.SEND_PHOTO, userId, poiId);
                setSuccessMessage(strings.will_be_posted);
                setSuccessTitle(strings.thanks_for_photo);
            } else {
                setError(resultAction.payload);
            }
        } catch (err) {
            setError(err.message);
            setAddRequestStatus('failed');
        } finally {
            setAddRequestStatus('idle');
        }

    };




    return (error ? <ErrorModal strings={strings} message={error} onClose={() => setError('')} /> :
            successTitle ? <ConfirmModal title={successTitle} message={successMessage} onClose={onGoBack}/> :
            <div className="modal" id="add_photo_modal">
                <div className="modal-body" id="add_photo_modal_body">
                    <div className="modal-border" onPointerDown={event => handlePointerDown(event, 'add_photo_modal_body')}>
                        <div className="move-handler"></div>
                    </div>
                    <div className="modal-content">
                        <div className="modal-header" onPointerDown={event => handlePointerDown(event, 'add_photo_modal_body')}>
            
                            <a className="close-modal" onPointerDown={event => {
                                    event.preventDefault();
                                    event.stopPropagation();
                                   }} onClick={event => {
                                       event.preventDefault();
                                       onGoBack();
                                   }}></a>
                            <span onPointerDown={event => event.preventDefault()}>{strings.add_photo}</span>
                            <hr/>
                        </div>
                        <form>
                            <input type="file" id="photo" name="file_name" onChange={onPhotoChanged} ref={photoRef} accept="image/*;capture=camera"/>
                            <button className="btn" id="select_photo_button" onClick={onSelectClicked}>
                            {addRequestStatus === 'pending' ? <div className="loader"></div> : strings.select}
                            </button>
                        </form>
                    </div>
                </div>
            </div>);
};

export default AddPhotoModal;

